import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography } from '@altermaind/web/ui';

type Props = {
  onRetry: () => void;
  onClose: () => void;
};

export const ErrorContent: FC<Props> = ({ onRetry, onClose }) => {
  const t = useTranslations('core.dialogContacts.error');

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Box
        display='flex'
        flexDirection='row'
        flex={0}
        borderRadius={100}
        bg='error'
        p='xxs'
        size='xxl'
        mb='m'
      >
        <Svg name='cross' size='l' fill='white' />
      </Box>
      <Typography variant='h3' color='primary/text' textAlign='center' mt='none'>
        {t('title')}
      </Typography>
      <Box mt='xs' mb='l'>
        <Typography variant='p2/light' textAlign='center' color='grey/light'>
          {t('description')}
        </Typography>
      </Box>
      <Box display='flex' flexDirection='row' style={{ gap: 16 }}>
        <Button variant='link/primary' onClick={onClose}>
          {t('close')}
        </Button>
        <Button variant='primary' onClick={onRetry}>
          {t('retry')}
        </Button>
      </Box>
    </Box>
  );
};
